export default __webpack_public_path__ + "static/media/carousel-image1.fb1ce9a1.jpg";